<template>
  <Content class="col-span-full" :title="$route.name" v-loading="loading">
    <el-form
      status-icon
      :model="ruleForm"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      :rules="rules"
      class="carpo-form demo-ruleForm"
    >
      <el-form-item :label="$t('DATE_')" prop="date">
        <date-picker
          color="#151515"
          class="el-input__inner"
          v-model="ruleForm.date"
          view="day"
          @change="dateChanged"
          :max="maxDate"
          format="jYYYY-jMM-jDD"
          clearable
          :locale="$i18n.locale"
        />
      </el-form-item>
    </el-form>
    <div v-if="result" class="flex justify-end">
      <el-button
        :loading="isDownloadLoading"
        type="primary"
        @click="downloadReport()"
      >
        {{ $t("DOWNLOAD_REPORT") }}
      </el-button>
    </div>

    <titleHolder :title="$t('MAX_SPEED')" v-if="result" />
    <div class="flex flex-col gap-8 overflow-scroll mb-8" v-if="result">
      <VueApexCharts
        v-if="series1.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series1"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('AVG_SPEED')" v-if="result" />
    <div class="flex flex-col gap-8 overflow-scroll mb-8" v-if="result">
      <VueApexCharts
        v-if="series2.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series2"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('ODOMETER')" v-if="result" />
    <div class="flex flex-col gap-8 overflow-scroll mb-8" v-if="result">
      <VueApexCharts
        v-if="series3.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series3"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('Amount_of_work_perday')" v-if="result" />
    <div class="flex flex-col gap-8 overflow-scroll mb-8" v-if="result">
      <VueApexCharts
        v-if="series7.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series7"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('acceleration')" v-if="result" />
    <div class="flex flex-col gap-8 overflow-scroll mb-8" v-if="result">
      <VueApexCharts
        v-if="series4.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series4"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('braking')" v-if="result" />
    <div class="flex flex-col gap-8 overflow-scroll mb-8" v-if="result">
      <VueApexCharts
        v-if="series5.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series5"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('cornering')" v-if="result" />
    <div class="flex flex-col gap-8 overflow-scroll mb-8" v-if="result">
      <VueApexCharts
        v-if="series6.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series6"
      ></VueApexCharts>
    </div>

    <titleHolder
      :title="$t('max_temperature')"
      v-if="result && hasMaxTemperature"
    />
    <div
      class="flex flex-col gap-8 overflow-scroll mb-8"
      v-if="result && hasMaxTemperature"
    >
      <VueApexCharts
        v-if="series10.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series10"
      ></VueApexCharts>
    </div>
    <titleHolder
      :title="$t('mean_temperature')"
      v-if="result && hasMeanTemperature"
    />
    <div
      class="flex flex-col gap-8 overflow-scroll mb-8"
      v-if="result && hasMeanTemperature"
    >
      <VueApexCharts
        v-if="series9.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series9"
      ></VueApexCharts>
    </div>

    <titleHolder
      :title="$t('min_temperature')"
      v-if="result && hasMinTemperature"
    />
    <div
      class="flex flex-col gap-8 overflow-scroll mb-8"
      v-if="result && hasMinTemperature"
    >
      <VueApexCharts
        v-if="series8.length"
        type="bar"
        height="450"
        :width="chartWidth"
        :options="chartOptions"
        :series="series8"
      ></VueApexCharts>
    </div>
  </Content>
</template>

<script>
import { DailyReport, DownloadDailyReport } from "@/api/reports";
import { jalaliToGregorian } from "@/mixins/jalaliToGregorian";
import VueApexCharts from "vue-apexcharts";
import { licenseChars } from "@/api/global";
import titleHolder from "@/components/elements/title.vue";
import { gregorianToJalali } from "@/mixins/gregorianToJalali";

export default {
  mixins: [jalaliToGregorian, gregorianToJalali],
  data() {
    return {
      alphaList: [
        {
          code: "",
          char: "",
          id: "",
        },
      ],
      labels: [],
      loading: false,
      isDownloadLoading: false,
      ruleForm: {
        date: "",
      },
      rules: {
        date: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("DATE_"),
            }),
            trigger: "blur",
          },
        ],
      },

      hasMaxTemperature: false,
      hasMeanTemperature: false,
      hasMinTemperature: false,

      series1: [],
      series2: [],
      series3: [],
      series4: [],
      series5: [],
      series6: [],
      series7: [],
      series8: [],
      series9: [],
      series10: [],
      chartOptions: {
        chart: {
          height: 450,
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: "10%",
            barWidth: 10,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          labels: {
            rotate: -90, // Rotate the labels further
            offsetY: 0,
            show: true,
          },
          categories: [],
          tickPlacement: "on",
        },

        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      result: false,
      resultCount: 0,
      chartWidth: "",
    };
  },

  methods: {
    downloadReport() {
      this.isDownloadLoading = true;
      const data = this.jalaliToGregorian(
        this.ruleForm.date,
        this.$i18n.locale
      );
      DownloadDailyReport.api(data)
        .then((res) => {
          this.isDownloadLoading = false;
          if (res) {
            var blob = new Blob([res], { type: "application/octet-stream" });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = `daily-report-${this.ruleForm.date}-CARPO.xlsx`;
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
          }
        })
        .catch((error) => {
          console.error("Download Error:", error);
        });
    },
    dateChanged() {
      const selectedDate = this.jalaliToGregorian(
        this.ruleForm.date,
        this.$i18n.locale
      );
      if (selectedDate) {
        this.loading = true;
        DailyReport.api(selectedDate).then((res) => {
          this.loading = false;
          this.result = false;
          this.resultCount = 0;
          this.series1 = [];
          this.series2 = [];
          this.series3 = [];
          this.series4 = [];
          this.series5 = [];
          this.series6 = [];
          this.series7 = [];
          this.series8 = [];
          this.series9 = [];
          this.series10 = [];
          if (res && res.length) {
            this.result = true;
            this.resultCount = res.length;
            this.chartWidth = this.resultCount > 20 ? 4000 : "100%";
            let test = res.map((item) => {
              const licensePlate = item.company_vehicle.license_plate;
              const plateCode = licensePlate.substring(7, 9);
              const plateNumber = licensePlate.substring(4, 7);
              const plateAlpha =
                this.alphaList.find(
                  (i) => i.code === licensePlate.substring(2, 4)
                )?.char || "";
              const platePrefix = licensePlate.substring(0, 2);

              const license = `${plateCode} | ${plateNumber} ${plateAlpha} ${platePrefix}`;
              return license;
            });

            const hasMaxTemp = res.some(
              (item) => item.max_temperature !== null
            );
            const hasMeanTemp = res.some(
              (item) => item.mean_temperature !== null
            );
            const hasMinTemp = res.some(
              (item) => item.min_temperature !== null
            );

            this.hasMaxTemperature = hasMaxTemp;
            this.hasMeanTemperature = hasMeanTemp;
            this.hasMinTemperature = hasMinTemp;

            this.series1 = [
              {
                name: this.$t("MAX_SPEED"),
                data: res.map((i) => i.max_speed),
              },
            ];

            this.series2 = [
              {
                name: this.$t("AVG_SPEED"),
                data: res.map((i) => i.mean_speed),
              },
            ];

            this.series3 = [
              {
                name: this.$t("ODOMETER"),
                data: res.map((i) => Math.ceil(i.traveled_distance / 1000)),
              },
            ];

            this.series4 = [
              {
                name: this.$t("acceleration"),
                data: res.map((i) => i.number_of_harsh_acceleration),
              },
            ];

            this.series5 = [
              {
                name: this.$t("braking"),
                data: res.map((i) => i.number_of_harsh_braking),
              },
            ];

            this.series6 = [
              {
                name: this.$t("cornering"),
                data: res.map((i) => i.number_of_harsh_cornering),
              },
            ];

            this.series7 = [
              {
                name: this.$t("WORK_TIME"),
                data: res.map((i) => (i.work_time / 60).toFixed(1)),
              },
            ];
            if (hasMaxTemp) {
              this.series10 = [
                {
                  name: this.$t("max_temperature"),
                  data: res.map((i) => i.max_temperature),
                },
              ];
            }

            if (hasMeanTemp) {
              this.series9 = [
                {
                  name: this.$t("mean_temperature"),
                  data: res.map((i) => i.mean_temperature),
                },
              ];
            }

            if (hasMinTemp) {
              this.series8 = [
                {
                  name: this.$t("min_temperature"),
                  data: res.map((i) => i.min_temperature),
                },
              ];
            }
            this.updateChartOptions();
            this.chartOptions.xaxis.categories = test;
          } else {
            this.result = false;
            this.hasMaxTemperature = false;
            this.hasMeanTemperature = false;
            this.hasMinTemperature = false;
            this.series1 = [];
            this.series2 = [];
            this.series3 = [];
            this.series4 = [];
            this.series5 = [];
            this.series6 = [];
            this.series7 = [];
            this.series8 = [];
            this.series9 = [];
            this.series10 = [];
            this.$notify.error({
              title: this.$i18n.t("NO_DATA"),
              duration: 4500,
              customClass: "error_msg",
            });
          }
        });
      }
    },
    updateChartOptions() {
      const isMobile = window.innerWidth <= 768;
      this.chartOptions.plotOptions.bar = {
        borderRadius: 10,
        columnWidth: isMobile || this.resultCount > 20 ? "50%" : "10%",
        barWidth: isMobile || this.resultCount > 20 ? 50 : 10,
      };
      this.chartOptions.xaxis.labels.offsetY = isMobile
        ? 0
        : this.resultCount > 20
        ? 80
        : 0;
      this.chartWidth =
        isMobile && this.resultCount > 20
          ? 4000
          : isMobile && this.resultCount < 20
          ? 1000
          : "100%";
    },
    handleResize() {
      this.updateChartOptions();
    },
  },
  mounted() {
    licenseChars.api().then((res) => {
      this.alphaList = res;
    });
    window.addEventListener("resize", this.handleResize);
    this.updateChartOptions();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  components: {
    VueApexCharts,
    titleHolder,
  },
  computed: {
    maxDate() {
      let todayDate = new Date()
        .toLocaleDateString("en-us")
        .replaceAll("/", "-")
        .split("-");
      todayDate = `${todayDate[2]}-${todayDate[0]}-${
        parseInt(todayDate[1]) > 1 ? +todayDate[1] - 1 : todayDate[1]
      }`;

      return this.gregorianToJalali(todayDate, "fa");
    },
  },
};
</script>
